<template>
    <input v-model="model" :min="min" :max="max" :type="type" @blur="$emit('blur')"/>
</template>

<script>
    import _ from "lodash";

    export default {
        delimiters: ["${", "}"],

        props:
            {
                template:
                    {
                        type: String,
                        default: "#vue-debounced-input"
                    },
                type: String,
                min: Number,
                max: Number,
                delay: {
                    type: Number,
                    default: 800
                },
                value: {}
            },

        data()
        {
            return {
                model: this.value,
                debounced: _.debounce(this.updateValue, this.delay)
            }
        },

        methods: {
            updateValue(){
                if (this.min && this.model < this.min) this.model = this.min;
                if (this.max && this.model > this.max) this.model = this.max;
                this.$emit("input",this.model);
            },

        },

        watch: {
            model(){
                // lodash debounce returns a function that then needs to be called
                this.debounced()
            },
            value(val){
                // update inner model on external changes
                this.model = val;
            }
        }
    }
</script>
